import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ProsemirrorViewerInput = _resolveComponent("ProsemirrorViewerInput");
    const _component_ThemedButton = _resolveComponent("ThemedButton");
    const _component_EditorNodeWrapper = _resolveComponent("EditorNodeWrapper");
    return (_openBlock(), _createBlock(_component_EditorNodeWrapper, {
        class: _normalizeClass([
            'node-container',
            'link-container',
            _ctx.blockWidthClass,
            {
                'parent-first-child': _ctx.parentFirstChild,
                'parent-last-child': _ctx.parentLastChild,
            },
        ]),
        onObserveNodeVisibility: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('observe-node-visibility', Object.assign(Object.assign({}, $event), { nodeId: _ctx.node.id }))))
    }, {
        default: _withCtx(() => [
            _createVNode(_component_ThemedButton, {
                class: _normalizeClass(['open-link-btn', _ctx.node.align.toLowerCase()]),
                "data-external": "view-link-button",
                theme: _ctx.theme,
                onClick: _ctx.handleClick
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_ProsemirrorViewerInput, {
                        class: "open-link-btn-text",
                        content: _ctx.node.content
                    }, null, 8, ["content"])
                ]),
                _: 1
            }, 8, ["class", "theme", "onClick"])
        ]),
        _: 1
    }, 8, ["class"]));
}
